<template>
    <div id="app">
        <comp-day-spark-line :device_id="device_id" :target_date="target_date" />
    </div>
</template>

<script>
import compDaySparkLine from "@/components/CompDaySparkLine";

export default {
    //#########################################################################################
    components: {
        compDaySparkLine,
    },
    //#########################################################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            device_id: null,
            target_date: this.$moment().format("YYYY-MM-DD"),
        };
    },
    //#########################################################################################
    created: async function () {
        this.device_id = this.$route.params.device_id;
        if (this.$route.params.target_date) {
            this.target_date = this.$route.params.target_date;
        }
    },
    //#########################################################################################
};
</script>
